export default "__VITE_ASSET__5w8jeEc8__"